import React from 'react';
import { withStyles } from '@material-ui/core/styles';
import FormGroup from '@material-ui/core/FormGroup';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import Checkbox from '@material-ui/core/Checkbox';
import Switch from '@material-ui/core/Switch';

import './VoiceComponent.css';



function VoiceComponent(props) {
  const {root, reverse, title} = props;
  const {u1, u2, u3, u4, u5} = props
  // const [state, setState] = React.useState({
  //   checkedRhythm: false,
  //   checkedPitch: false,
  //   checkedTimbre: false,
  //   source: `${root}`,
  //   target: `${reverse}`,
  //   converted: `${root}_S`,
  //   isReversed: false,
  // });
 


  return (
    <div className="wrapper">
      <p className="block-label">{title}</p>
        {/* <audio controls ref={audio1}>
          <source src={`/audio/${state.source}_S.wav`} type="audio/wav" />

          Your browser does not support the audio element.
        </audio> */}
       <div className="rowv">
          <div className="element">
            <p>Source speech:</p>
            <audio controls>
              <source src={u1} type="audio/wav" />

              Your browser does not support the audio element.
            </audio>
          </div>
          {/* <div className="element">
            <p>Target emotion's example utterance:</p>
            <audio controls>
              <source src={u2} type="audio/wav" />

              Your browser does not support the audio element.
            </audio>
          </div> */}
       </div>
       <div className="rowv">
          <div className="element">
            <p>AutoVC</p>
            <audio controls>
              <source src={u3} type="audio/wav" />

              Your browser does not support the audio element.
            </audio>
          </div>
          <div className="element">
            <p>RR</p>
            <audio controls>
              <source src={u4} type="audio/wav" />

              Your browser does not support the audio element.
            </audio>
          </div>
          <div className="element">
            <p>AutoPST(Proposed)</p>
            <audio controls>
              <source src={u5} type="audio/wav" />

              Your browser does not support the audio element.
            </audio>
          </div>
       </div>
    </div>
    
  );
}

export default VoiceComponent;
